import { Dashboard } from "components";
import BroadcastChannelView from "./BroadcastChannelView";

export const BroadcastChannelContainer = () => {
  return (
    <Dashboard>
      <BroadcastChannelView />
    </Dashboard>
  );
};
